import ActionTypes from '../actions/types';
import { defaultState } from './defaultState';
import { setState } from './helper';

const initialState = defaultState.pusher;

export default (state = initialState, action) => {
  switch(action.type) {
    case ActionTypes.SET_PUSHER_SOCKET_ID:
      return setState(state, action, 'socketId');
      
    default:
      return state;
  }

};



// WEBPACK FOOTER //
// ./src/reducers/pusherReducer.js